import { queryOptions, skipToken } from "@tanstack/react-query";

import {
  createDealShortlistTeaserEmailPresetV2,
  previewDealTeaserEmailV2,
} from "@vega-api/generated/coinvest-deal-teaser-email-v2/coinvest-deal-teaser-email-v2";
import { type TeaserEmailContact } from "@vega-api/generated/types/teaserEmailContact";

type DraftEmailPresetQueryParams = {
  dealId: string;
  dealShortlistItemId: string;
  /** Omit (pass undefined) to keep the query disabled until the sender is known. */
  sender: TeaserEmailContact | undefined;
};

/**
 * Query factory for the teaser-email preset. Orval models the endpoint as a
 * mutation (POST — the sender goes in the body) so it generates no reusable
 * query key/options. skipToken disables it until a sender is supplied.
 */
export const draftEmailPresetQueryOptions = ({
  dealId,
  dealShortlistItemId,
  sender,
}: DraftEmailPresetQueryParams) =>
  queryOptions({
    queryKey: [
      "deal-shortlist-teaser-email-preset",
      dealId,
      dealShortlistItemId,
      sender?.userId,
    ],
    queryFn: sender
      ? ({ signal }) =>
          createDealShortlistTeaserEmailPresetV2(
            dealId,
            { dealShortlistItemId, sender },
            undefined,
            signal,
          )
      : skipToken,
    select: (response) => response.data,
  });

type DraftEmailPreviewQueryParams = {
  dealId: string;
  dealShortlistItemId: string;
  body: string | undefined;
};

export const draftEmailPreviewQueryOptions = ({
  dealId,
  dealShortlistItemId,
  body,
}: DraftEmailPreviewQueryParams) =>
  queryOptions({
    queryKey: ["deal-teaser-email-preview", dealId, dealShortlistItemId, body],
    queryFn:
      body != null
        ? ({ signal }) =>
            previewDealTeaserEmailV2(
              dealId,
              { dealShortlistItemId, body },
              undefined,
              signal,
            )
        : skipToken,
    select: (response) => response.data.html,
  });
